<div class="internal" id="main">
  <div class="section modifica-ristorante" id="modifica-ristorante">
    <div class="content-body">
      <div class="content">
        <div class="search">
          <div class="fieldset">
            <label for="Restaurants">{{
              "restaurant.select_restaurant" | translate
            }}</label>
            <p-select
              [(ngModel)]="selectedRestaurant"
              [options]="Restaurants"
              [filter]="true"
              [style]="{ width: '100%' }"
              optionLabel="dropdownLabel"
              placeholder="{{ 'restaurant.select_restaurant' | translate }}"
              (onChange)="onRestaurantChange($event)"
            />
          </div>
        </div>
        @if (selectedRestaurant) {
        <app-restaurant-form
          [edit]="true"
          [ships]="ships"
          [selectedRestaurant]="selectedRestaurant"
          (restaurantUpdated)="showResult($event)"
        ></app-restaurant-form>
        } @else {
        <div class="buttons">
          <button class="costa-button outline" type="button" (click)="Back()">
            {{ "cancel" | translate }}
          </button>
        </div>
        }
      </div>
    </div>
  </div>
</div>
